











































































import {Vue, Component} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class TipoviObjekata extends mixins(ComponentBaseMixin) {
  isBusySave = false;
  tableData = [];
  editableObject = {id: 0, code: '', publicId: '', name: ''};
  columns = [];
  tableOptions = {
    pagination: true,
    onClickRow: row => this.onClickRow(row)
  };

  async created() {
    this.columns = [
      {field: 'code', sortable: true, title: this.$i18n.t('kod')},
      {field: 'name', sortable: true, title: this.$i18n.t('naziv')}
    ];
  }

  mounted() {
    //(<any>this.$refs.observer).validate();
    this.loadData();
  }

  async loadData() {
    this.tableData = [];
    let table = $('#table');
    try {
      table.bootstrapTable('showLoading');
      const {data} = await this.axios.get('/api/GetStoreTypes');
      this.tableData = data;
    } catch (err) {
      table.bootstrapTable('hideLoading');
      this.showError('greskaPrilikomUcitavanja');
    } finally {
      table.bootstrapTable('hideLoading');
    }
  }

  onClickRow(row) {
    this.editableObject = row;
  }

  newEntry() {
    this.editableObject = {id: 0, code: '', publicId: '', name: ''};
  }

  async save() {
    const valid = await (<any>this.$refs.observer).validate();
    if (valid) {
      try {
        this.isBusySave = true;
        const {data} = await this.axios.post('/api/SaveStoreType', this.editableObject);
        this.editableObject.id = data;
        await this.loadData();
        this.showInfo('podaciUspesnoSacuvani');
      } catch (err) {
        this.isBusySave = false;
        this.showError('neuspesnoCuvanjePodataka');
      } finally {
        this.isBusySave = false;
      }
    } else {
      this.showInfo('nisu sva obavezna polja popunjena');
    }
  }

}
